import React, { useEffect, Suspense, lazy, useState } from 'react'
import { faThLarge, faThList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Container from 'elements/Container'
import { isBrowser } from 'react-device-detect'
import { MobileFilterWrapper, PoolFilter, PoolFilterButton, PoolFilterRight, Title } from './styled'
import { useDispatch, useSelector } from 'react-redux'
import useStatePersist from 'hooks/useStatePersist'
import { selectNft } from 'state/nft/slice'
import fetchNft from 'state/nft/actions/fetchNft'
import Search from './Filters/Search'
import ChangeOrder from './Filters/ChangeOrder'
import Fallback from 'components/Fallback'
import NotFound from './NotFound'
import { LoaderWrapper } from './TableLayout/styled'
import Loader from 'components/Loader'
import fetchFavoritedNft from 'state/nft/actions/fetchFavoritedNft'
import { selectNftFavorites, setFavoriteMode } from 'state/nftFavorites/slice'

const TableLayout = lazy(() => import('./TableLayout'))
const CardLayout = lazy(() => import('./CardLayout'))

const VIEW_MODE = {
  CARD: 'CARD',
  LIST: 'LIST'
}

function NftStats() {
  const dispatch = useDispatch()
  const nft = useSelector(selectNft)
  const { favoriteMode } = useSelector(selectNftFavorites)
  const [viewMode, setViewMode] = useStatePersist(VIEW_MODE.LIST, 'nftViewMode')
  const [ready, setReady] = useState(false)
  const searchMode = nft.search.length > 0

  useEffect(() => {
    if (!nft.isFirstTimeLoad && ready) {
      if (favoriteMode) {
        dispatch(fetchFavoritedNft())
      } else {
        dispatch(fetchNft())
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteMode])

  useEffect(() => {
    if (nft.isFirstTimeLoad && !searchMode) {
      if (favoriteMode) {
        dispatch(fetchFavoritedNft())
      } else {
        dispatch(fetchNft())
      }
    }

    setReady(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Container>
        <Title>NFT Stats</Title>
        <div>
          <Search mobile />
          <PoolFilter>
            <div>
              <PoolFilterButton active={!favoriteMode} onClick={() => dispatch(setFavoriteMode(false))}>
                All
              </PoolFilterButton>
              <PoolFilterButton active={favoriteMode} onClick={() => dispatch(setFavoriteMode(true))}>
                Favorite
              </PoolFilterButton>
            </div>
            <PoolFilterRight>
              <ChangeOrder />
              <Search />
              <MobileFilterWrapper>
                <PoolFilterButton
                  style={{ fontSize: '1.2rem' }}
                  onClick={() => setViewMode(VIEW_MODE.CARD)}
                  active={viewMode === VIEW_MODE.CARD}
                >
                  <FontAwesomeIcon icon={faThLarge} />
                </PoolFilterButton>
              </MobileFilterWrapper>
              <MobileFilterWrapper>
                <PoolFilterButton
                  style={{ fontSize: '1.2rem' }}
                  onClick={() => setViewMode(VIEW_MODE.LIST)}
                  active={viewMode === VIEW_MODE.LIST}
                >
                  <FontAwesomeIcon icon={faThList} />
                </PoolFilterButton>
              </MobileFilterWrapper>
            </PoolFilterRight>
          </PoolFilter>
        </div>
        <Suspense fallback={<Fallback height="70vh" />}>
          {nft.status === 'loading' ? (
            <LoaderWrapper>
              <Fallback height="70vh" />
            </LoaderWrapper>
          ) : nft.status === 'idle' && !nft.items.length ? (
            <NotFound />
          ) : viewMode === VIEW_MODE.LIST && isBrowser ? (
            <TableLayout />
          ) : (
            <CardLayout />
          )}
        </Suspense>
      </Container>
    </>
  )
}

export default NftStats
